<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="30%"
      title="添加"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto">
        <el-form-item label="收益类型" >
          <el-radio-group v-model="form.type">
            <el-radio label="3">课程收益</el-radio>
            <!-- <el-radio label="5">开店基金</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收益来源" >
          <el-radio-group v-model="form.from_mec">
            <el-radio :label="v.id" v-for="(v, i) in mecList" :key="i">{{
              v.mechanism_name
            }}</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="收益金额" >
          <el-input v-model="form.amount" placeholder="金额"></el-input>
        </el-form-item>
         <el-form-item label="收益时间" >
          <el-date-picker
      v-model="form.create_time"
      type="datetime"
      value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期时间">
    </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button type="primary" @click="addNew()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      form:{},
      addServiceDialog:false,
      mechanism_id:'',
      mecList:[]
    };
  },

  mounted() {
    this.mechanism_id = this.$route.query.mecID
    this.getSubMec()
  },

  methods: {
    getSubMec(){
        let param = {
            parent_id:this.$route.query.mecID || '-2'
        }
        this.$get('user/mastermechanism/query',param).then(res=>{
            this.mecList = res.data.data
        })
    },
    open() {
   
      this.form = {}
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/user/mechanismAccountRecord/add";
        this.form.mechanism_id = this.mechanism_id
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/shared/venueArea/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>